import { useContext } from 'react';

import { UserPreferencesContext } from '../context/UserPreferencesContext';

export function useCurrency(): [CurrencyCode] {
  const { preferences } = useContext(UserPreferencesContext);

  return [preferences.currency];
}
